import { __decorate } from "tslib";
import colors from '@/styles/color.scss';
import lang from '@blade-sxp/portrait-management/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import CombinedPicture from '@blade-sxp/portrait-management/components/combined-picture.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { LibStatusEnum, PageOrderEnum, PageQueryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { Scale } from '@blade/common/utils/auto-scale';
import { EPortraitStatus, EPassCodeStatus, } from '@blade-sxp/portrait-management/interfaces/portrait';
import { deletePortraitRelation } from '@blade-sxp/portrait-management/api/portrait';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { SYSTEMCODE } from '@blade/common/constants/code';
import PassCodeDialog from '@blade-sxp/portrait-management/components/pass-code/index.vue';
const Webapi = {
    deletePortraitRelation,
};
let default_1 = class default_1 extends Vue {
    data;
    selection;
    loading;
    pagination;
    refresh;
    curPassInfo = {
        portraitId: '',
        qrCodeState: '',
    };
    passCodeDialogVisible = false;
    // 权限级别
    permissionlevel = permissionlevel;
    systemCode = SYSTEMCODE;
    defaultPageSize = [32]; //  [16, 32, 80, 160];
    defaultSort = { prop: 'updateTime', order: 'descending' };
    defaultTableMinWidth = {
        selection: 48 * Scale,
        name: 182 * Scale,
        idPhoto: 142 * Scale,
        libName: 230 * Scale,
        updatedBy: 190 * Scale,
        updatedAt: 220 * Scale,
        action: 104 * Scale,
    };
    filterLibraryStatus = [];
    cellBackground = colors.colorBoxBg;
    fontColor = '';
    // 提交中
    submiting = false;
    portraitStatus = 'INVALIDATING'; // 失效
    columns = [
        {
            prop: 'name',
            label: this.$t('name'),
            width: 190,
            fixed: true,
        },
        {
            prop: 'icCard',
            label: this.$t('icCardNumber'),
            width: 130,
            fixed: false,
        },
        {
            prop: 'image',
            label: this.$t('idPhoto'),
            width: 87,
            fixed: false,
        },
        {
            prop: 'libName',
            label: this.$t('faceLib'),
            width: 184,
            fixed: false,
        },
        {
            prop: 'updateBy',
            label: this.$t('updatedBy'),
            width: 164,
            fixed: false,
        },
        {
            prop: 'updateTime',
            label: this.$t('updatedAt'),
            width: 187,
            fixed: false,
        },
        {
            prop: 'validDate',
            label: this.$t('effectiveDate'),
            width: 320,
            fixed: false,
        },
        {
            prop: 'portraitStatus',
            label: this.$t('portraitStatus'),
            width: 152,
            fixed: false,
        },
        {
            prop: 'action',
            label: this.$t('action'),
            // clazz: 'action-cloumn',
            width: 196,
            fixed: 'right',
        },
    ];
    portraitStatusConfig = {
        [EPortraitStatus.NORMAL]: {
            color: colors.vaDotGreenText,
            label: this.$t('valid'),
        },
        [EPortraitStatus.UNEFFECTIVE]: {
            color: colors.searchYellow,
            label: this.$t('notExpired'),
        },
        [EPortraitStatus.INVALIDATING]: {
            color: colors.dodBlack,
            label: this.$t('expired'),
        },
    };
    passCodeStepKey = 'view';
    get curPassValidDate() {
        const { validEndTime, validStartTime } = this.curPassInfo;
        return validEndTime && validStartTime ? [validStartTime, validEndTime] : [];
    }
    get computedDisablePassCode() {
        return (data) => {
            return data?.portraitStatus === EPortraitStatus.INVALIDATING; // || data?.qrCodeState === EPassCodeStatus.UNGENERATE;
        };
    }
    get computedTd() {
        return (data, prop) => {
            return data?.[prop] ?? '-';
        };
    }
    get computedValidDate() {
        return (data) => {
            return data?.validStartTime && data?.validEndTime ? `${data?.validStartTime}~${data?.validEndTime}` : '-';
        };
    }
    get computedStatus() {
        return (data) => {
            const target = this.portraitStatusConfig?.[data?.portraitStatus];
            return target?.label ?? '-';
        };
    }
    get computedStatusDotStyle() {
        return (data) => {
            const target = this.portraitStatusConfig?.[data?.portraitStatus];
            return {
                background: target?.color,
            };
        };
    }
    getCheck(val) {
        return val?.portraitStatus === this.portraitStatus;
    }
    /** 模糊尺寸 */
    get blurSize() {
        return this.privacyMode ? 6 : 0;
    }
    /** 是否开启隐私模式 */
    get privacyMode() {
        return localStorage.getItem('privacyMode') === 'true';
    }
    /** 身份照片最大宽度 */
    get idPhotoMaxWidth() {
        return 240 * Scale;
    }
    /** 身份照片最大高度 */
    get idPhotoMaxHeight() {
        return 240 * Scale;
    }
    initI18n() {
        this.filterLibraryStatus = [
            { text: String(this.$t('enable')), value: LibStatusEnum.ENABLE },
            { text: String(this.$t('disabled')), value: LibStatusEnum.DISABLE },
        ];
    }
    selectionChange(selection) {
        this.$refs.portraitTable.clearSelection();
        if (!selection)
            selection = this.selection;
        if (selection) {
            selection.forEach((row) => {
                this.$refs.portraitTable.toggleRowSelection(row);
            });
        }
    }
    getInvalid(row) {
        return row.portraitStatus === this.portraitStatus ? `pointer-events: none;color:${colors.grey2}` : ``;
    }
    selectable(row) {
        // 判断是否失效禁用
        return !(row.portraitStatus === this.portraitStatus);
    }
    tableRowClassName(row) {
        if (row.row.portraitStatus === this.portraitStatus) {
            return `color:${colors.grey2}`;
        }
        else {
            return '';
        }
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.$emit('update:pagination', this.pagination);
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.$emit('update:pagination', this.pagination);
    }
    handleSelectionChange(val) {
        this.$emit('update:selection', val);
    }
    sortChange(order) {
        this.pagination.pageOrderList = [
            {
                orderField: 'updateTime',
                orderType: order.order === 'ascending' ? PageOrderEnum.ASC : PageOrderEnum.DESC,
            },
        ];
        this.$emit('update:pagination', this.pagination);
        this.refresh();
    }
    cellClick(row, column) {
        if (column.property === 'name') {
            this.$refs[`popover-` + row.libId].doClose();
        }
    }
    handleName(item) {
        const query = this.$route.query;
        this.$router.push({ name: 'portraitCreate', query: { ...query, type: PageQueryTypeEnum.DETAIL, id: item.portraitId.toString() } });
    }
    handleEdit(item) {
        const query = this.$route.query;
        this.$router.push({ name: 'portraitCreate', query: { ...query, type: PageQueryTypeEnum.EDIT, id: item.portraitId.toString() } });
    }
    /**
     * @description: 删除
     */
    handleDelete(item) {
        if (this.loading)
            return;
        this.$elconfirm(`${this.$t('deletePortraitTip')}`, `${this.$t('tip')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.cancel')}`,
            confirmButtonText: ` ${this.$t('common.confirm')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    this.deletePortraitRelation(item);
                }
            },
        });
    }
    async deletePortraitRelation(item) {
        try {
            this.$emit('update:loading', true);
            await Webapi.deletePortraitRelation(item);
            this.$message({
                customClass: 'success-message',
                message: this.$t('deletedSuccessfully'),
                type: 'success',
                showClose: true,
            });
            this.handleCurrentChange(1);
            this.refresh();
        }
        catch (error) {
            this.$emit('update:loading', false);
            console.log('deletePortraitRelation error', error);
        }
    }
    handlePassCode(data) {
        this.passCodeDialogVisible = true;
        this.curPassInfo = { ...data };
        this.passCodeStepKey = this.curPassInfo?.qrCodeState === EPassCodeStatus.UNGENERATE ? 'add' : 'view';
        console.log('  this.curPassInfo ', this.curPassInfo);
    }
    mounted() {
        this.initI18n();
    }
    created() { }
};
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
__decorate([
    Prop()
], default_1.prototype, "selection", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "pagination", void 0);
__decorate([
    Prop()
], default_1.prototype, "refresh", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        i18n: { messages: lang },
        components: { BlurPicture, CombinedPicture, AuthNewitem, PassCodeDialog },
    })
], default_1);
export default default_1;
